import { getToken } from "./user-service";
import axios from "axios";

/**
 * Search for flights by various criteria
 * 
 * @param {Object} params - Search parameters
 * @param {string} params.iata - Airport IATA code (required)
 * @param {string} params.date - Date in YYYY-MM-DD format (required)
 * @param {string} params.searchTerm - Search term (required) - searches flight number, carrier code, aircraft reg, gate, stand
 * @returns {Promise<Array>} Array of matching flights
 */
export const searchFlights = async (params) => {
    const token = await getToken();

    // Build query string
    const queryParams = new URLSearchParams({
        iata: params.iata,
        date: params.date,
        searchTerm: params.searchTerm,
    });

    // API Gateway routes /api/v1/flights to prm-flights-service
    // prm-flights-service has /flight-search route registered
    const url = `/api/v1/flights/flight-search?${queryParams.toString()}`;

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(url, {
                headers: { "Firebase-UID": token },
            });

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Issue searching flights");
            }

            resolve(response.data);
        } catch (e) {
            console.error("Error searching flights:", e);
            reject(new Error(e.response?.data?.errors?.[0]?.msg || "Error searching flights"));
        }
    });
};


